export const DATE_FORMAT = 'YYYY-MM-DD'
export const JDATE_FORMAT = 'YYYY/jMM/jDD'
export const JMONTH_NAME_FORMAT = 'MMMM'
export const JMONTH_FORMAT = 'M'
export const DATE_FORMAT_SLASH = 'YYYY/MM/DD'

export const TIME_FORMAT = "HH:mm";

export const PERSIAN_DATE="DD MMMM YYYY ساعت: HH:mm"


